import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import type { UpdateExperienceRequest } from 'app/typings/core/admin/experiences/experienceForm';
import { isHttpApiError } from 'app/utils/error';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type UpdateExperienceParams = {
  id: number;
  payload: UpdateExperienceRequest;
};

export function useUpdateExperience() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: UpdateExperienceParams) =>
      apiMutation(
        'PATCH',
        { path: ENDPOINTS.updateExperience, params: { id: id.toString() } },
        payload
      ) as Promise<ExperienceResponse>,
    onSuccess: (response, variables) => {
      message.success('Activity successfully updated');

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.experience, { id: variables.id.toString() }],
        response
      );

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.experiences],
      });
    },
    onError: (error) => {
      const errorMessage = isHttpApiError(error)
        ? error.jsonObject.errorMessage
        : 'Failed to update activity.';

      message.error(errorMessage);
    },
  });
}
